export default function Avatar({ photo, avatar, name = '', initials, size = 32, bg = '#f5eeeb', color = '#8b1a2a', style = {} }) {
  const base = { width: size, height: size, borderRadius: '50%', flexShrink: 0, ...style };
  if (photo) return <img src={photo} alt={name} style={{ ...base, objectFit: 'cover', border: '1px solid #c49090' }} />;
  const center = { ...base, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center' };
  if (avatar) return <div style={{ ...center, fontSize: Math.max(14, Math.round(size * 0.5)) }}>{avatar}</div>;
  const txt = (initials || (name || 'A').slice(0, 2)).toUpperCase();
  return <div style={{ ...center, fontSize: Math.max(12, Math.round(size * 0.4)), fontWeight: 700, color }}>{txt}</div>;
}
